"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketManager = void 0;
const DomainEvents_1 = require("../utils/DomainEvents");
const Observable_1 = require("./Observable");
class SocketManager {
    constructor(organizationId, organizationUser, socketAdapter) {
        this.organizationId = organizationId;
        this.organizationUser = organizationUser;
        this.socketAdapter = socketAdapter;
        this._connectionStatus = {
            isConnected: false,
            isConnecting: false,
            retryCount: 0,
        };
        this.removeListeners = [];
        this.organizationId = organizationId;
        this.organizationUser = organizationUser;
        this.socketAdapter = socketAdapter;
        this.removeListeners.push(Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_CONNECT, this.organizationId), () => __awaiter(this, void 0, void 0, function* () {
            this.onSocketConnect();
        })));
        this.removeListeners.push(Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_RECONNECT_ATTEMPT, this.organizationId), (data) => __awaiter(this, void 0, void 0, function* () {
            this.onSocketReconnectAttempt(data.attemptNumber);
        })));
        this.removeListeners.push(Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_RECONNECT_FAILED, this.organizationId), () => __awaiter(this, void 0, void 0, function* () {
            this.onSocketDisconnect();
        })));
        this.removeListeners.push(Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_DISCONNECT, this.organizationId), () => __awaiter(this, void 0, void 0, function* () {
            this.onSocketDisconnectPendingRetry();
        })));
    }
    get connectionStatus() {
        return this._connectionStatus;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateConnectionStatus({
                isConnected: false,
                isConnecting: true,
                retryCount: 0,
            });
            yield this.organizationUser.open();
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socketAdapter.close();
            this.updateConnectionStatus({
                isConnected: false,
                isConnecting: false,
                retryCount: 0,
            });
        });
    }
    destroy() {
        this.removeListeners.forEach(unsubscribe => unsubscribe());
        this.removeListeners = [];
    }
    onSocketConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateConnectionStatus({
                isConnected: true,
                isConnecting: false,
                retryCount: 0,
            });
        });
    }
    // The below code is making the socket disconnection page visible immediately before the reconnect completes
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSocketReconnectAttempt(attemptNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            // this.updateConnectionStatus({
            //   isConnected: false,
            //   isConnecting: true,
            //   retryCount: attemptNumber,
            // });
        });
    }
    onSocketDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateConnectionStatus({
                isConnected: false,
                isConnecting: false,
                retryCount: 0,
            });
        });
    }
    onSocketDisconnectPendingRetry() {
        return __awaiter(this, void 0, void 0, function* () {
            Observable_1.Observable.getInstance().notify(DomainEvents_1.SocketStatusEvents.DISCONNECTED_PENDING_RETRY, {});
        });
    }
    updateConnectionStatus(connectionStatus) {
        this._connectionStatus = connectionStatus;
        Observable_1.Observable.getInstance().notify(DomainEvents_1.SocketStatusEvents.ON_CHANGE, {});
    }
}
exports.SocketManager = SocketManager;
